module.exports = __webpack_public_path__ + "img/voice_2.101fb4ce.svg";